import React, { useState, useEffect } from 'react';
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  Timestamp,
  query,
  orderBy
} from 'firebase/firestore';
import { Row, Col, Form, Spinner } from 'react-bootstrap';
import {
  FaTimesCircle,
  FaUserSlash,
  FaUserPlus,
  FaBan,
  FaInfoCircle,
  FaUserFriends
} from 'react-icons/fa';
import { toast } from 'react-toastify';

const BannedListAdminLight = () => {
  const [bannedPeople, setBannedPeople] = useState([]);
  const [form, setForm] = useState({ first: '', last: '', reason: '' });
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  const db = getFirestore();

  // Firestore collection name as defined in production
  const BANNED_COLLECTION = "banned_list";

  const fetchBanned = async () => {
    setFetching(true);
    try {
      const q = query(collection(db, BANNED_COLLECTION), orderBy("addedAt", "desc"));
      const snap = await getDocs(q);
      setBannedPeople(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      console.error("Error fetching banned list:", err);
      toast.error("Failed to load banned list");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchBanned();
  }, []);




  return (
    <div className="qr-table-container p-4 shadow-lg border-0" style={{ background: 'var(--brand-dark-glass)' }}>
      {/* Header Section */}


      {/* List Section */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="qr-subtext fw-bold m-0 small" style={{ letterSpacing: '1px' }}>CURRENTLY BANNED INDIVIDUALS &nbsp;</h6>
        <span className="badge rounded-pill bg-danger" style={{ fontSize: '0.7rem' }}>{bannedPeople.length} Records</span>
      </div>

      <div className="qr-card-list" style={{ maxHeight: '500px', overflowY: 'auto' }}>
        {fetching ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="light" size="sm" />
            <p className="qr-subtext mt-2 small">Loading registry...</p>
          </div>
        ) : bannedPeople.length > 0 ? (
          bannedPeople.map(p => (
            <div key={p.id} className="qr-log-card d-flex justify-content-between align-items-center mb-2 py-3 shadow-sm  border-1">
              <div className="ps-3">
                <div className="fw-bold text-white" style={{ fontSize: '1.1rem' }}>
                  {p.firstName} {p.lastName}
                </div>
                <div className="qr-subtext-small text-danger fw-bold mt-1">
                  <FaInfoCircle className="me-1" size={12} /> {p.reason}
                </div>
                <div className="text-white-50" style={{ fontSize: '0.65rem' }}>
                  Added: {p.addedAt?.toDate().toLocaleDateString()}
                </div>
              </div>

            </div>
          ))
        ) : (
          <div className="text-center py-5 qr-subtext bg-dark rounded border border-secondary border-dashed" style={{ borderStyle: 'dashed' }}>
            <FaUserFriends size={30} className="opacity-25 mb-2" />
            <p className="m-0">No active bans found in the registry.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BannedListAdminLight;